import { captureException } from '@sentry/react';
import { concatPath } from '../../../helpers/path';
import { RootPath, ManagerPath, AuthPath } from '../../../routes/manager/manager-enums';
import { refresh } from '../auth-api';
import { appendHeaders } from './headers';

let isRefreshing = false;
let refreshPromise: Promise<void> | null = null;
let globalAbortController: AbortController | null = null;

export const catchError = async (
  response: Response,
  url: string,
  options?: RequestInit & { customCache?: boolean },
) => {
  const code = response.status;

  if (code === 401) {
    if (!isRefreshing) {
      // отменяет прочие запросы, если уже идет обновление токена
      isRefreshing = true;
      globalAbortController = new AbortController();
      refreshPromise = refresh().finally(() => {
        isRefreshing = false;
        refreshPromise = null;
        globalAbortController = null;
      });
    }

    if (globalAbortController) {
      globalAbortController.abort();
    }

    try {
      await refreshPromise;
    } catch (error) {
      const redir = concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Login]);
      window.location.replace(redir);
      captureException(new Error(`Catched: refresh is expired`), {
        tags: { refresh: 'expired' },
      });
      throw new Error('Refresh failed');
    }

    return await fetch(url, {
      ...options,
      headers: appendHeaders(options?.headers),
    });
  }
  captureException(response);
  throw new Error(String(code));
};
